import React, { useState } from 'react';

import { Button, Drawer, Group, Stack } from '@mantine/core';
import EventTypeMultiSelectAutoComplete, {
  IEventTypeMultiSelectAutoComplete,
} from 'components/form-fields/auto-complete-fields/EventTypeMultiSelectAutoComplete';
import LocationMultiSelectAutoComplete from 'components/form-fields/auto-complete-fields/LocationMultiSelectAutoComplete';
import StaffMultiSelectAutoComplete from 'components/form-fields/auto-complete-fields/StaffMultiSelectAutoComplete';
import { useStaffTracking } from 'hooks/mixpanel/useStaffTracking';

import { FilterTerms } from '../types';

interface ISchedulingPageHeaderProps {
  opened: boolean;
  searchFilters: FilterTerms;
  initialSearchFiltersValue: FilterTerms;
  setSearchFilters: React.Dispatch<React.SetStateAction<FilterTerms>>;
  closeFilters: () => void;
}

const FiltersDrawer = ({
  opened,
  searchFilters,
  initialSearchFiltersValue,
  setSearchFilters,
  closeFilters,
}: ISchedulingPageHeaderProps): JSX.Element => {
  const staffTracking = useStaffTracking();
  const [eventTypes, setEventTypes] = useState<IEventTypeMultiSelectAutoComplete[]>([]);

  const handleEventTypesChange = (values: IEventTypeMultiSelectAutoComplete[]): void => {
    setEventTypes(values);
    const eventTypeIds = values.map(v => v.eventTypeId);
    setSearchFilters(prev => ({ ...prev, eventTypes: eventTypeIds }));
    staffTracking.trackcalendarFilterApplied('event_types', eventTypeIds.join(',') || 'none');
  };
  const handleCoachesChange = (values: string[]): void => {
    setSearchFilters(prev => ({ ...prev, coaches: values }));
    staffTracking.trackcalendarFilterApplied('coaches', values.join(',') || 'none');
  };
  const handleLocationsChange = (values: string[]): void => {
    setSearchFilters(prev => ({ ...prev, locations: values }));
    staffTracking.trackcalendarFilterApplied('locations', values.join(',') || 'none');
  };

  const handleClearFilters = (): void => {
    setSearchFilters(initialSearchFiltersValue);
    setEventTypes([]);
    staffTracking.trackcalendarFilterApplied('clear_all', 'all_cleared');
  };

  return (
    <Drawer position='bottom' opened={opened} onClose={closeFilters} size={'xs'}>
      <Stack spacing='sm'>
        <Group position='right'>
          <Button color='red' onClick={handleClearFilters}>
            Clear Filters
          </Button>
        </Group>
        <EventTypeMultiSelectAutoComplete handleChange={handleEventTypesChange} values={eventTypes} />
        <LocationMultiSelectAutoComplete onChange={handleLocationsChange} value={searchFilters.locations} />
        <StaffMultiSelectAutoComplete onChange={handleCoachesChange} value={searchFilters.coaches} isCoach />
      </Stack>
    </Drawer>
  );
};

export default FiltersDrawer;
